module.exports = __webpack_public_path__ + "static/media/Argos - Teams - Purple.6b90acbf.svg";